import request from "@/utils/request";
import { initGetParams } from "@/utils/index";

export function login(data) {
  return request({
    url: "/credit/accountLogin/0000/login",
    method: "post",
    data,
  });
}
export function logOut(data) {
  return request({
    url: "/credit/accountLogin/0000/signOut",
    method: "post",
    data,
  });
}

export function modifyPwd(data) {
  return request({
    url: "/credit/account/2001001008/modifyPassword",
    method: "post",
    data,
  });
}

export function generateUuid(data) {
  return request({
    url: "/busUserController/0000/generateUuid",
    method: "get",
    data,
  });
}
export function queryToken(data) {
  return request({
    url: "/credit/busUserController/0000/queryToken",
    method: "get",
    params: data,
  });
}


//************门户 */
//轮播图
export function getCarousel(data) {
  return request({
    url: `/credit/image/0000/list?${initGetParams(data)}`,
    method: "get"
  });
}
//企业注册
export function register(data) {
  return request({
    url: "/credit/enterprise/0000/register",
    method: "post",
    data,
  });
}
//注册发送验证码
export function sendSmsVerCode(data) {
  return request({
    url: `/credit/enterprise/0000/getCode?${initGetParams(data)}`,
    method: "get",
  });
}

//注册图片验证码是否正确
export function checkVerCode(data) {
  return request({
    url:`/credit/accountLogin/0000/check?${initGetParams(data)}`,
    method: "get",
  });
}
//获取新闻  1-通知公告 2-政策咨询 3-政策申报
export function getNews(data) {
  return request({
    url: `/credit/news/0000/page?${initGetParams(data)}`,
    method: "get"
  });
}
//新闻详情
export function getNewsDetail(data) {
  return request({
    url: `/credit/news/0000/${data.id}`,
    method: "get"
  });
}
//企业门户端-畅销产品
export function getWellSells(data) {
  return request({
    url: `/credit/financialProduct/0000/getTOP3?${initGetParams(data)}`,
    method: "get"
  });
}

//企业门户端-信贷产品
export function getCreditSells(data) {
  return request({
    url: `/credit/financialProduct/0000/getAll?${initGetParams(data)}`,
    method: "get"
  });
}

//企业门户端-热门产品
export function getHotSells(data) {
  return request({
    url: `/credit/financialProduct/0000/getPageTop?${initGetParams(data)}`,
    method: "get"
  });
}
//企业门户端-金融产品详情
export function getProductDetail(data) {
  return request({
    url: `/credit/financialProduct/0000/detailPortal?${initGetParams(data)}`,
    method: "get"
  });
}
//融资动态-企业端
export function getActivList(data) {
  return request({
    url: `/credit/productOrder/0000/orderStatus?${initGetParams(data)}`,
    method: "get"
  });
}
//金融机构分页
export function getOrganList(data) {
  return request({
    url: `/credit/financialInstitution/0000/portalPage?${initGetParams(data)}`,
    method: "get"
  });
}
// 数据字典
export const getDictionaryByKeys = (data) => {
  const params = [];
  data.forEach((val) => {
    params.push(`code=${val}`);
  });
  return request({
    url: `/credit/dictionary/2001005005?${params.join("&")}`,
    method: "get",
  });
};
//查看企业信息导出次数
export function getExportCont() {
  return request({
    url: `/credit//enterprise/0000/2001050004/count`,
    method: "get"
  });
}

//导出企业详细信息
export function getExportDetail() {
  return request({
    url: `/enterprise/2001050004/exportDetai`,
    method: "get"
  });
}

//企业申请金融产品
export function applyProduct(data) {
return request({
  url: "/credit/productOrder/2001048001",
  method: "post",
  data,
});
}


//导出企业基础信息
export function getExportBasic() {
  return request({
    url: `/enterprise/2001050004/export`,
    method: "get"
  });
}


//企业门户-金融产品分页
export function getProductList(data) {
  return request({
    url: `/credit/financialProduct/0000/portalPage?${initGetParams(data)}`,
    method: "get",
  });
}
//获取数据字典
export function getDictionaryKeys(data) {
  const params = [];
  data.forEach((val) => {
    params.push(`code=${val}`);
  });
  return request({
    url: `/credit/dictionary/0000?${params.join("&")}`,
    method: "get",
  });
}

//问答-分页查询（门户）

export function getQuestionList(data) {
  return request({
    url: `/credit/question/0000/page?${initGetParams(data)}`,
    method: "get",
  });
}

// 上传附件
export const uploadFiles = (data) => {
  return request({
    url: "/credit/fileMio/uploadPublic",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// 上传附件-免登录
export const uploadFilesNoLogin = (data) => {
  return request({
    url: "/credit/fileMio/0000/uploadPublic",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

//企业端-我的融资交易
export function getProductOrderList(data) {
  return request({
    url: `/credit/productOrder/2001048008?${initGetParams(data)}`,
    method: "get",
  });
}


//查询是否申请过金融产品
export function getIsApplyFor(data) {
  return request({
    url: `/credit/productOrder/2001048012?${initGetParams(data)}`,
    method: "get",
  });
}


//首页-统计
export function getStatistics(data) {
  return request({
    url: `/credit/enterprise/0000/statistics?${initGetParams(data)}`,
    method: "get",
  });
}


//企业门户-融资需求分页
export function getNeedstList(data) {
  return request({
    url: `/credit/enterpriseFinancingNeed/0000/getPage?${initGetParams(data)}`,
    method: "get",
  });
}

//企业门户端-融资需求详情
export function getNeedsDetail(data) {
  return request({
    url: `/credit/enterpriseFinancingNeed/2001051005?${initGetParams(data)}`,
    method: "get"
  });
}